import { messageChannelProviderSchema } from "./message-channel.js";
import * as z$1 from "zod/v4";
//#region src/schemas/runtime/channel-context.ts
const CHANNEL_CONTEXT_MAX_MESSAGES = 20;
const CHANNEL_CONTEXT_MESSAGE_TEXT_MAX_CHARS = 4e3;
const CHANNEL_CONTEXT_TOTAL_TEXT_MAX_CHARS = 16e3;
const nonEmptyStringSchema = z$1.string().trim().min(1);
const channelContextAuthorSchema = z$1.strictObject({
	kind: z$1.enum([
		"human",
		"agent",
		"bot",
		"system",
		"unknown"
	]),
	id: nonEmptyStringSchema.max(256).optional(),
	displayName: nonEmptyStringSchema.max(256).optional()
});
const channelContextMessageSchema = z$1.strictObject({
	id: nonEmptyStringSchema.max(256),
	author: channelContextAuthorSchema,
	sentAtMs: z$1.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER),
	text: nonEmptyStringSchema.max(CHANNEL_CONTEXT_MESSAGE_TEXT_MAX_CHARS)
});
const channelContextSyncSchema = z$1.strictObject({
	mode: z$1.enum(["snapshot", "delta"]),
	status: z$1.enum([
		"complete",
		"truncated",
		"unavailable",
		"forbidden",
		"rate_limited"
	])
});
const channelContextSchema = z$1.strictObject({
	provider: messageChannelProviderSchema,
	conversationId: nonEmptyStringSchema.max(512),
	currentMessageId: nonEmptyStringSchema.max(256),
	sync: channelContextSyncSchema,
	messages: z$1.array(channelContextMessageSchema).max(20)
}).superRefine((context, refinement) => {
	if (context.sync.status !== "complete" && context.sync.status !== "truncated" && context.messages.length > 0) refinement.addIssue({
		code: "custom",
		message: "Unavailable channel context statuses cannot include message records.",
		path: ["messages"]
	});
	const messageIds = /* @__PURE__ */ new Set();
	let previousSentAtMs = -1;
	let totalTextCharacters = 0;
	for (const [index, message] of context.messages.entries()) {
		if (messageIds.has(message.id)) refinement.addIssue({
			code: "custom",
			message: "Channel context message identifiers must be unique.",
			path: [
				"messages",
				index,
				"id"
			]
		});
		messageIds.add(message.id);
		if (message.id === context.currentMessageId) refinement.addIssue({
			code: "custom",
			message: "The current trigger message must not be duplicated in channel context.",
			path: [
				"messages",
				index,
				"id"
			]
		});
		if (message.sentAtMs < previousSentAtMs) refinement.addIssue({
			code: "custom",
			message: "Channel context messages must be ordered by sentAtMs.",
			path: [
				"messages",
				index,
				"sentAtMs"
			]
		});
		else previousSentAtMs = message.sentAtMs;
		totalTextCharacters += message.text.length;
	}
	if (totalTextCharacters > 16e3) refinement.addIssue({
		code: "custom",
		message: "Channel context message text exceeds the total size limit.",
		path: ["messages"]
	});
});
//#endregion
export { CHANNEL_CONTEXT_MAX_MESSAGES, CHANNEL_CONTEXT_MESSAGE_TEXT_MAX_CHARS, CHANNEL_CONTEXT_TOTAL_TEXT_MAX_CHARS, channelContextAuthorSchema, channelContextMessageSchema, channelContextSchema, channelContextSyncSchema };

//# sourceMappingURL=channel-context.js.map